<template>
  <div class="all-settings">
    <base-header class="pb-6">
      <b-row class="py-3">
        <b-col lg="6" cols="7">
          <h2 class="text-xl d-inline-block mb-0">All Templates</h2>
          <p class="text-muted">All tempates for send sms, email & notification to users.</p>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <el-tabs>
				<el-tab-pane label="Customer Status">
          <CustomerStatusTable />
        </el-tab-pane>
        <el-tab-pane label="Case Status">
          <CaseStatusTable />
        </el-tab-pane>
        <el-tab-pane label="Disbursement Status">
          <DisbursementStatusTable />
        </el-tab-pane>
      </el-tabs>
    </b-container>
  </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import CaseStatusTable from '@/views/AllSettings/StatusPages/CaseStatus/CaseStatusTable'
import CustomerStatusTable from '@/views/AllSettings/StatusPages/CustomerStatus/CustomerStatusTable'
import DisbursementStatusTable from '@/views/AllSettings/StatusPages/DisbursementStatus/DisbursementStatusTable'

export default {
  components: {
    CustomerStatusTable,
    CaseStatusTable,
    DisbursementStatusTable,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  }
}
</script>